import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import IRegion from './types/Region';

class RegionsApi {
    static getRegions(): any {
        return new Promise<any>((resolve: any, reject: any) => {
            new Api()
                .get('/regions')
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    static createRegion(region: any): any {
        return new Promise<any>(
            (resolve: (response: IRegion) => void, reject: (error: any) => void) => {
                new Api()
                    .post('/regions', region)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static editRegion(id: number): any {
        return new Promise<any>(
            (resolve: (response: IRegion) => void, reject: (error: any) => void) => {
                new Api()
                    .get(`/regions/${id}/edit`)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static updateRegion(region: any): any {
        return new Promise<any>(
            (resolve: (response: IRegion) => void, reject: (error: any) => void) => {
                new Api()
                    .put(`/regions/${region.id}`, region)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static deleteRegion(id: number): any {
        return new Promise<any>((resolve: () => void, reject: (error: any) => void) => {
            new Api()
                .delete(`/regions/${id}`)
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }
}

export default RegionsApi;
